import $ from 'jquery'
import * as project from './functions'
import { gsap, Power2 } from "gsap"

window.onload = () => {
    project.lazyLoad()
    project.resizeScreen()

    if ($('.slider-init').length > 0) {
        $('.slider-init').each(function () {
            project.setupSlideshow($(this), $(this).data('slick'), $(this).data('slides'))
        })
    }

    var windowWidth = $(window).width();
    if (windowWidth > 800) {
        //animateThumbnail();
    }

    $('<div id="close-search"></div>').appendTo('#block-b5subtheme-search-form')

    $('#block-b5subtheme-footer a.legal-and-credits').click(function (e) {
        e.preventDefault();
        var $legalBlock = $('#block-b5subtheme-legalcredits');
        $legalBlock.addClass('show');
        //keyUpClose($legalBlock);
    });

    $('#block-b5subtheme-footerit a.legal-and-credits').click(function (e) {
        e.preventDefault();
        var $legalBlock = $('#block-b5subtheme-legalcredits');
        $legalBlock.addClass('show');
        //keyUpClose($legalBlock);
    });

    $('.page-taxonomy .close-preview, #block-b5subtheme-legalcredits .close-icon').click(function (e) {
        e.preventDefault();
        $('#block-b5subtheme-search-form, #block-b5subtheme-legalcredits').removeClass('show');
    });

    $('#block-b5subtheme-secondarymenu li a[data-drupal-link-system-path="search"]').click(function (e) {
        e.preventDefault();
        $('#block-b5subtheme-search-form').fadeIn('fast');
    });

    $('#close-search').click(function (e) {
        e.preventDefault();
        $('#block-b5subtheme-search-form').fadeOut('fast');
    });

    $('#toggle-main-menu').click(function () {
        $('ul.nice-menu li.menuparent ul').removeClass('open');
        $('.navbar-collapse').toggleClass('show');
        $('#toggle-main-menu .bar').toggleClass('animate');
    });


    //gsap.from('.view-projects.view-display-id-page_1 .view-content .views-row', { y: 45, autoAlpha: 0, stagger: 0.15, ease: Power2.easeInOut })


    const bodyClasses = $('body').attr("class").split(/\s+/)

    $.each(bodyClasses, function (key, value) {
        switch (value) {
            case "page-node-type-project":
                console.log("page-node-type-project")
                console.log('activePath')
                project.setupSlideshow('.group-header > .field--name-field-gallery')
                $('.page-node-type-homepage .slick-dots').appendTo('.page-node-type-project .group-header .field--name-node-title');
                let activePath = $('main').data('drupal-link-active-path');
                console.log('activePath ' + activePath)

                $('.nav-link[data-drupal-link-system-path="' + activePath +'"]').addClass('is-active')
                break
            case "page-node-type-homepage":
                console.log("page-node-type-homepage")
                project.setupSlideshow('.view-id-projects.view-display-id-block_2 .view-content')
                project.setupSlideshow('.field--name-field-projects.field__items')

                $('.field--name-field-projects.field__items .field__item').each(function (index) {
                    $(this).find('.node--view-mode-project-preview').addClass($(this).find(".field--name-field-slideshow-title-position").text())
                });
               
                break
            case "path-taxonomy":
                console.log("path-taxonomy")
                project.setupSlideshow('.block-views-blockservices-header-block-1 .field--name-field-gallery')
                $('.block-views-blockservices-header-block-1 .field--name-field-gallery .slick-dots').appendTo('.block-views-blockservices-header-block-1 .group-right');
                break
            case "page-node-57":
                console.log("page-node-57")
                project.setupSlideshow('.field--name-field-gallery', 'images')
                //$('.block-views-blockservices-header-block-1 .field--name-field-gallery .slick-dots').appendTo('.block-views-blockservices-header-block-1 .group-right');
                break
            case "page-node-54":
                console.log("page-node-57")
                project.setupSlideshow('.field--name-field-gallery', 'images')
                //$('.block-views-blockservices-header-block-1 .field--name-field-gallery .slick-dots').appendTo('.block-views-blockservices-header-block-1 .group-right');
                break
            case "path-studio":
                $('<div class="close-icon"></div>').appendTo('.view-id-people .field--name-body')
                if (windowWidth >= 1025) {
                    project.toggleDescription('.view-id-people .views-row', 4);
                } else if (windowWidth < 1025 && windowWidth >= 800) {
                    project.toggleDescription('.view-id-people .views-row', 3);
                } else if (windowWidth < 800 && windowWidth >= 480) {
                    project.toggleDescription('.view-id-people .views-row', 1);
                } else {
                    project.toggleDescription('.view-id-people .views-row', 1);
                }
                break
            default:
                $('#loader').fadeOut(500)
        }
    })
}

(function ($, Drupal, window, document, undefined) {
    
})(jQuery, Drupal, this);

